<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-plane-up" aria-hidden="true"></i></span>{{ 'AirportMaintenance.Header' | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">

        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- Airport Code (IATA) slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formAirportCode">{{ 'AirportMaintenance.Form.Field.AirportCode' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="100"
                id="formAirportCode"
                formControlName="airportCode"
              />
            </div>

            <!-------------------------------------- Airport Name slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formAirportName">{{ 'AirportMaintenance.Form.Field.AirportName' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="255"
                id="formAirportName"
                formControlName="airportName"
              />
            </div>

            <!-------------------------------------- Located City slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formLocatedCityName">{{ 'AirportMaintenance.Form.Field.LocatedCityName' | translate }}</label>
              <p-multiSelect
                inputId="formLocatedCityName"
                appendTo="body"
                placeholder="{{ 'AirportMaintenance.Form.Placeholder.OptionHint.SelectOneOrMoreCity' | translate }}"
                display="chip"
                formControlName="locatedCitySeqNo"
                optionLabel="name"
                optionValue="seqNo"
                [virtualScroll]="true"
                [itemSize]="40"
                [options]="cityOptions"
              ></p-multiSelect>
            </div>

          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

            <!-------------------------------------- Query Button ---------------------------------------------->
            <button pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}"
            ></button>

            <!-------------------------------------- Reset Button ---------------------------------------------->
            <button pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"
            ></button>

          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #table
      [columns]="selectedColumns"
      [value]="tableData"
      [loading]="isLoading"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      dataKey="dataKey"
      editMode="row"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped mt-2 white-space: nowrap;"
    >

      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>

        <!-------------------------------------- Add Button ---------------------------------------------->
        <button pButton
          class="p-button-success p-button-raised ml-2"
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
        ></button>

        <!-------------------------------------- Delete Button ---------------------------------------------->
        <button pButton
          class="p-button-danger p-button-raised ml-2"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
        ></button>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate }}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
        ></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'AirportMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableDate()"
        ></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
        ></button>

      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width:15vw">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col"
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- Airport Code (IATA) Column ---------------------------------------------->
            <td *ngSwitchCase="'airportCode'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableAirportCode"></label>
                  <input pInputText
                    type="text"
                    id="tableAirportCode"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Airport Name Column ---------------------------------------------->
            <td *ngSwitchCase="'airportName'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableAirportName"></label>
                  <input pInputText
                    type="text"
                    id="tableAirportName"
                    maxlength="255"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Located City Name Column ---------------------------------------------->
            <td *ngSwitchCase="'locatedCityName'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableLocatedCityName"></label>
                  <p-dropdown
                    inputId="tableLocatedCityName"
                    appendTo="body"
                    class="p-fluid"
                    placeholder="{{ 'AirportMaintenance.Table.Placeholder.OptionHint.SelectACity' | translate}}"
                    optionLabel="name"
                    optionValue="seqNo"
                    [filter]="true"
                    [options]="cityOptions"
                    [showClear]="true"
                    [(ngModel)]="rowData['locatedCitySeqNo']"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ getCityNameBySeqNo(rowData['locatedCitySeqNo']).name | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Is Activated Column ---------------------------------------------->
            <td *ngSwitchCase="'isActivated'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    inputId="tablesActivated"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'AirportMaintenance.Table.Placeholder.OptionHint.SelectIsActivatedOrNot' | translate }}"
                    [showClear]="true"
                    [options]="isActivatedOptions"
                    [(ngModel)]="rowData[col.field]"
                  >
                    <ng-template pTemplate="selectedItem" let-value>
                      {{ value.label | translate }}
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                      {{ item.label | translate }}
                    </ng-template>
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: isActivatedOptions | replaceNullWith: "-" | translate }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- CreateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- UpdateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Default ---------------------------------------------->
            <td *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
